<!-- Page Wrapper -->

<div class="content container-fluid">
    <div class="bg-white page-border">

        <div class="row row-replace add-m-b">
            <!-- header  -->
            <div class="col-12 col-p text-center">
                <div class="row">
                    <div class="col-10">
                        <img src="assets/img/logo.png" width="180" class="m-b-10">
                    </div>
                    <div class="col-2" *ngIf="empStatus == 'ex' || empStatus == ''">
                        <button class="btn btn-sm btn-danger" (click)="logout()">
                         LogOut
                        </button>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-10">
                        <h2>Mobilise Job Portal </h2>
                    </div>
                </div>
            </div>
        </div>

        <!--page body contant -->
        <!--header row-->
        <div class="row row-replace add-m-b">
            <div class="col-md-6 col-p h5"> <i class="fa fa-suitcase"></i> JOB / JOB DETAILS</div>
            <div class="col-md-6 top-corner-items col-p">
                <button class="btn btn-primary btn-sm" [routerLink]="['/alumni/external-jobs']"><i class="fa fa-arrow-left"></i> Back</button>
            </div>
        </div>
        <!--start page contant-->
        <div class="row">
            <div class="col-md-8 col-p">
                <section class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="col-12 bg-primary text-white add-p-tb5">
                                Job Details
                            </div>
                            <div class="job-info job-widget mb0">
                                <div class="row">
                                    <!-- <div class="col-md-4">
                                            <h3 class="card-title">Job title : {{ijp_detail.job_title}}</h3>
                                        </div> -->
                                    <div class="col-md-12">
                                        <h3 class="card-title">{{ijp_detail.ijp_code}} : {{ijp_detail.desig_desc}} , Designation : {{ijp_detail.desig_desc}}</h3>

                                    </div>
                                </div>
                                <ul class="job-post-det">
                                    <li><i class="fa fa-calendar"></i> Posted Date: <span class="text-blue">{{ijp_detail.created_at}}</span></li>
                                    <!-- <li><i class="fa fa-calendar"></i> Last Date: <span class="text-blue">{{ijp_detail.reqd_by}}</span></li> -->
                                    <li><i class="fa fa-users m-r-5"></i> Total Applications: <span class="text-blue">{{ijp_detail.applicants}}</span></li>
                                    <li><i class="fa fa-eye m-r-5"></i> Views: <span class="text-blue">{{ijp_detail.views}}</span></li>

                                </ul>
                                <ul class="job-post-det">
                                    <li *ngIf="ijp_detail.attachment"> <i class="fa fa-info-circle" aria-hidden="true"></i> Attachment
                                        <a [href]="ijp_detail.attachment" target="_blank" >
                                            <i class="fa fa-download"></i></a>
                                    </li>
                                    <li> <i class="fa fa-file-text" aria-hidden="true"></i> Policy
                                        <a *ngIf="ijp_detail.policy" [href]="ijp_detail.policy" target="_blank" >
                                            <i class="fa fa-download"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="col-12 bg-primary text-white add-p-tb5">
                                Description
                            </div>
                            <div class="job-info job-widget mb0">
                                <div class="job-desc-title">
                                    <h4>Short Description</h4>
                                    <span [innerHtml]="ijp_detail.short_desc"></span>
                                </div>

                                <!-- <div *ngIf="ijp_detail.job_desc != ''" class="job-desc-title mt-15">
                                        <h4>Detailed description</h4>
                                        <span [innerHtml]="ijp_detail.job_desc"></span>
                                    </div> -->

                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-12">
                           
                            <iframe id="frame" style="height: 300px !important"
                            width="100%"
                            class="border-0 border-up-down" [src]="youtube_detail.SafeUrl"></iframe>
                           
                    
                        </div>
                    </div> -->
                </section>
            </div>
            <div class="col-md-4">
                <div class="job-det-info job-widget">
                    <span *ngIf="empStatus == 'ex'">
                        <span class="btn job-btn job-btn-change" *ngIf="ijp_detail.is_applied != 0">Applied</span>
                    <a *ngIf="ijp_detail.is_applied == 0" class="btn job-btn job-btn-change" href="javascript:void(0);" data-toggle="modal" (click)="addJobModal('231')">Apply Now</a>
                    </span>
                    <!--share icon-->
                    <div class="info-list add-p-t0">
                        <section class="row row-replace">
                            <div class="col-6 bg-success1 p-10" *ngIf="empEntity != '2'" (click)="shareMedia1()">
                                <span class="text-white"><i class="fa fa-share-alt"></i></span>
                                <span class="font-14 m-l-5 text-white">Share on Social Media</span>
                            </div>
                            <div class="col-6 bg-danger1 p-10" (click)="addJobModal('')">
                                <span class="text-white"><i class="fa fa-user-plus"></i></span>
                                <span *ngIf="empEntity" class="font-14 m-l-5 text-white">Refer A Candidate </span>
                                <span *ngIf="!empEntity" class="font-14 m-l-5 text-white">Apply Now </span>
                            </div>
                        </section>
                    </div>
                    <!--end share icon-->
                    <div class="info-list">
                        <span><i class="fa fa-money"></i></span>
                        <!-- <h5>Salary</h5> -->
                        <!-- <p>Rs {{ ijp_detail.est_bgdt_frm | number:'1.0':'en-US' }}</p> -->
                        <!-- <p *ngIf="checkBugetfrom(ijp_detail.est_bgdt_frm) == true">
                            {{ijp_detail.est_bgdt_frm | number:'1.0':'en-US' }}
                        </p>
                        <p *ngIf="checkBugetfrom(ijp_detail.est_bgdt_frm) == false">
                            {{ijp_detail.est_bgdt_frm }}
                        </p> -->
                    </div>
                    <div class="info-list">
                        <span><i class="fa fa-suitcase"></i></span>
                        <h5>Experience</h5>
                        <p>{{ijp_detail.exp_frm}} - {{ijp_detail.exp_to}} years</p>
                    </div>
                    <div class="info-list">
                        <span><i class="fa fa-map-marker"></i></span>
                        <h5>Location</h5>
                        <p> {{ijp_detail.address1}}
                            <br> {{ijp_detail.ct_name}} {{ijp_detail.st_name}} 121001
                        </p>
                    </div>
                    <div class="info-list">
                        <span><i class="fa fa-phone"></i></span>
                        <h5>Contact</h5>
                        <p class="text-truncate"> {{ijp_detail.created_by}} {{ijp_detail.created_lname}}
                            <br> <a href="mailto:{{ijp_detail.created_email}}">{{ijp_detail.created_email}}</a>
                            <br> <a href="https://mobilise.co.in" target="_blank">https://mobilise.co.in</a>
                        </p>
                    </div>
                    <!-- <div class="info-list">
                            <span><i class="fa fa-envelope"></i></span>
                            <h5>Application Last Date</h5>
                            <p class="text-truncate">{{ijp_detail.reqd_by}} </p>
                        </div> -->


                </div>
            </div>
        </div>
        <!--end page body contant -->
    </div>
</div>

<!-- /Page Wrapper -->



<!--Refer a friends modal -->

<div id="apply_job_modal" class="modal custom-modal fade" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">×</span>
           </button>
            </div>
            <div class="card mb-0 card-border0">
                <div class="card-body card-body-top">
                    <form [formGroup]="jobApplyForm" (ngSubmit)="applyJob()">
                        <div class="row">
                            <div class="col-lg-12">
                                <h3 class="card-title mb-0">New Candidate</h3>
                                <hr/>

                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="exampleFormControlTextarea1">CV</label>
                                        <div class="upload-btn-wrapper text-center text-primary">
                                            <i class="fa fa-upload fa-5x"></i>
                                            <h5 class="mt-3" id="candEmpFile">Upload file</h5>
                                            <input type="file" class="form-control" (change)="onFileChangeCv($event)" />
                                        </div>
                                        <h5 class="text-primary">Max file size: 10MB. File format: doc, docx, pdf..</h5>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="exampleFormControlTextarea1">Photo</label>
                                        <div class="upload-btn-wrapper text-center text-primary">
                                            <i class="fa fa-image fa-5x"></i>
                                            <h5 class="mt-3" id="candEmpPhoto">Image</h5>
                                            <input type="file" class="form-control" (change)="onFileChangePhoto($event)" />
                                        </div>
                                        <h5 class="text-primary">Max file size: 2MB. File format: png, jpg, jpeg.</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="firstName" class="title">First Name <span class="form-error">*</span></label>
                                        <input type="text" formControlName="first_name" class="form-control" />
                                        <div *ngIf="submitted && apply.first_name.errors" class="form-error">
                                            <div *ngIf="apply.first_name.errors.required">First name is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="lastName">Last Name <span class="form-error">*</span></label>
                                        <input type="text" formControlName="last_name" class="form-control" />
                                        <div *ngIf="submitted && apply.last_name.errors" class="form-error">
                                            <div *ngIf="apply.last_name.errors.required">Last name is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="emailAddress">Email Address </label>
                                        <input type="email" class="form-control" formControlName="email" />
                                        <!-- <div *ngIf="submitted && apply.email.errors" class="form-error"> -->
                                        <!-- <div *ngIf="apply.email.errors.required">Email is required</div> -->
                                        <div *ngIf="(submitted || apply.email.touched) && apply.email.errors" class="form-error">
                                            <!-- <div *ngIf="apply.email.errors.email">Email address must be valid</div> -->
                                            <div *ngIf="apply.email.errors.email">Email must be a valid email address</div>
                                        </div>
                                        <!-- </div> -->
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="phoneNumber">Phone Number <span class="form-error">*</span></label>
                                        <input type="text" class="form-control" formControlName="phone" maxlength="10" />
                                        <div *ngIf="(submitted || apply.phone.touched) && apply.phone.errors" class="form-error">
                                            <div *ngIf="apply.phone.errors.required">Phone number is required</div>
                                            <div *ngIf="apply.phone.errors.minlength">Phone number must be of 10 characters</div>
                                            <div *ngIf="apply.phone.errors.maxlength">Phone number must be of 10 characters</div>
                                            <div *ngIf="apply.phone.errors.pattern">Enter only number.</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="forGender">Gender </label>
                                        <select2 [data]="gendList" value="value" placeholder="Gender" formControlName="gender">
                                        </select2>
                                        <div *ngIf="submitted && apply.gender.errors" class="form-error">
                                            <div *ngIf="apply.gender.errors.required">Gender is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="Compitency">Key Skills </label>
                                        <input type="text" class="form-control" formControlName="compitency" />
                                        <div *ngIf="submitted && apply.compitency.errors" class="form-error">
                                            <div *ngIf="apply.compitency.errors.required">Key Skills is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="forAadhar">Aadhar number</label>
                                        <input type="text" formControlName="aadhar_no" class="form-control" maxlength="12" />
                                        <div *ngIf="(submitted || apply.aadhar_no.touched) && apply.aadhar_no.errors" class="form-error">
                                            <div *ngIf="apply.aadhar_no.errors.required">Aadhar number is required</div>
                                            <div *ngIf="apply.aadhar_no.errors.minlength">Aadhar number must be of 12 characters</div>
                                            <div *ngIf="apply.aadhar_no.errors.maxlength">Aadhar number must be of 12 characters</div>
                                            <div *ngIf="apply.aadhar_no.errors.pattern">Enter only number.</div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="coverLetter">Cover Letter</label>
                                        <textarea class="form-control" id="coverLetter" formControlName="cover_letter" rows="3"></textarea>
                                        <div *ngIf="submitted && apply.cover_letter.errors" class="form-error">
                                            <div *ngIf="apply.cover_letter.errors.required">Please enter cover letter</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <button type="submit" [disabled]="loading" class="btn btn-primary btn-sm"> <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span> Submit</button>
                                        <button type="button" class="btn btn-danger btn-sm ml-10" (click)="resetJobApplyForm()">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<!--//Apply Job-->


<!--socal media modal-->

<div class="modal custom-modal fade" id="socal_media" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Social Media</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                   <span aria-hidden="true">×</span>
               </button>
            </div>
            <div class="modal-body">
                <p class="text-center h5">Job Posting on Social Media</p>
                <div class="row text-center">

                    <div class="col-4">
                        <a href="https://www.facebook.com/sharer/sharer.php?u={{fb_share}}/facebook" target="_blank">
                            <img src="assets/img/social-icon/facebook.png" style="height: 30px;">
                        </a>
                        <!-- <a href="https://www.facebook.com/login.php" target="_blank">
                      </a> -->
                        <!-- <i class="fa fa-facebook fa-2x"></i> -->
                        <p>facebook</p>
                    </div>
                    <div class="col-4">
                        <a href="https://www.linkedin.com/sharing/share-offsite/?url={{fb_share}}/linkedin" target="_blank">
                            <img src="assets/img/social-icon/linkedin.png" style="height: 30px;">
                            <!-- <i class="fa fa-linkedin fa-2x"></i> -->
                        </a>
                        <p>linkedin</p>
                    </div>
                    <div class="col-4">
                        <a href="https://wa.me/?text={{fb_share}}/whatsapp" target="_blank">
                            <img src="assets/img/social-icon/whatsapp.png" style="height: 30px;">
                        </a>

                        <p>Whats App</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--end socal media modal-->